/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import * as yup from 'yup';
import { Form as FormUi, Button, Label, Modal, Icon, Table, } from 'semantic-ui-react';
import { Field as Fieldmik, FieldArray, Formik} from 'formik';
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';
import { MyInput } from '../formikInput/input';
import PSLineItemDropdown from '../dropdowns/psLineItemDropdown';


const PenaltiesModal = ({ billData, approveBillsSelected, handleClosePayments, ...props }) => {

    const [penaltiesData, setPenaltiesData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        
        setIsLoading(true)

        let data = JSON.stringify
            ({
                customerNo: localStorage.getItem('customerNo'),
                userId: localStorage.getItem('userId'),
                billReferenceNo: billData.refNo
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getPenalty`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('apiToken')
            }
        }).then((response => {
            setPenaltiesData(response.data.data)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
            setIsLoading(false)

    },[])

    if(penaltiesData.length === 0){

        return (<>No Records Found</>)

    } else {

        let penaltyDetails = []
        penaltiesData && penaltiesData.map((o,i) => {
            let temp ={}
            temp.psCode = o.psCode
            temp.penaltyAmt = o.penaltyAmt
            
            penaltyDetails[i] = temp
        })

        const initialValues = {
            penaltyList: penaltyDetails ? penaltyDetails : [{
                psCode: '',
                penaltyAmt: ''
            }]
        };

        const onSubmit = (values) => {
            console.log("Modal Values", values)

            let approveBillData = [{
                billReferenceNo: billData.refNo,
                vendorCode: billData.vendorCode,
                approvalStatus: 'Approved',
                penaltyList: values.penaltyList
            }]

            approveBillsSelected(approveBillData)
        };

        return (
            <>
                <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                >
                    {({ touched, errors, handleSubmit, isSubmitting}) => (
                        <>    
                            <FieldArray
                                name={`penaltyList`}
                            >
                                {({push, remove, form}) => {

                                    const { initialValues, values, setFieldValue } = form
                                    const { penaltyList } = values

                                    console.log("Modal Val", penaltiesData, values)

                                    return (
                                        <>
                                        <Table verticalAlign>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>
                                                        <label className="labelName p-bold-600">Expense Particular</label>
                                                    </Table.HeaderCell>
                                                    <Table.HeaderCell colSpan="5">
                                                        <label className="labelName p-bold-600">Penalty Amount</label>
                                                    </Table.HeaderCell>
                                                </Table.Row>

                                            </Table.Header>
                                            <Table.Body>
                                                {penaltyList.map((penalty,penaltyIndex) => (
                                                    
                                                    <Table.Row>
                                                        <Table.Cell>    
                                                            <FormUi.Field width={3}>
                                                                <Fieldmik name={`penaltyList[${penaltyIndex}].psCode`} component={PSLineItemDropdown} placeholder="Enter Expense Code" value={penalty.psCode} />
                                                                {touched.psCode && errors.psCode ? <Label size="mini" prompt pointing>{errors.psCode}</Label> : ''}
                                                            </FormUi.Field>
                                                        </Table.Cell> 

                                                        <Table.Cell>    
                                                            <FormUi.Field width={3}>
                                                                <Fieldmik name={`penaltyList[${penaltyIndex}].penaltyAmt`} component={MyInput} placeholder="Enter Amount" />
                                                                {touched.penaltyAmt && errors.penaltyAmt ? <Label size="mini" prompt pointing>{errors.penaltyAmt}</Label> : ''}
                                                            </FormUi.Field>
                                                        </Table.Cell> 
                                                        <Table.Cell width={2}>
                                                            { penaltyIndex > 0 ? 
                                                            <Button onClick={() => remove(penaltyIndex)} type="button" basic size="mini" icon>
                                                                <Icon className="overhere" color="red" name="trash" />
                                                            </Button> 
                                                            : 
                                                            ''}
                                                        </Table.Cell>
                                                    </Table.Row>  
                                                        
                                                    
                                                ))}
                                            </Table.Body>
                                            </Table>
                                            <Button type="button" onClick={() => push({ psCode: '', penaltyAmt: '' })} size="mini" basic color="blue" style={{ position: 'relative', left: '400px', bottom: '8px' }}>
                                                + Add
                                            </Button>
                                        
                                        </>
                                    )
                                }}                                    
                            </FieldArray>
                                                            
                            <Modal.Actions>
                                <Button onClick={handleClosePayments} size="mini">Cancel</Button>
                                <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>Submit</Button>
                            </Modal.Actions>
                        </>
                    )}
                </Formik>
            </>
        )
    }
}


export default PenaltiesModal
